<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid" @keyup.native.enter="valid && submit($event)">
        <v-text-field
          v-model="username"
          :rules="usernameRules"
          :label="this.$store.getters['translate/translater']
          .__('Username', 'users')"
          required
        ></v-text-field>
        <v-text-field
          v-model="password"
          :rules="passwordRules"
          type="password"
          :label="this.$store.getters['translate/translater']
          .__('Password', 'users')"
          required
        ></v-text-field>
        <v-btn
          :disabled="!valid"
          @click="submit"
        >
          {{this.$store.getters['translate/translater']
          .__('Login', 'users')}}
        </v-btn>
      </v-form>
    </v-flex>
    </v-layout>
</template>

<script>

  //import {translater} from '../../tools/translate';
  import {AUTHORIZATION} from '../../constants';
  import {usernameRules} from '../../validation/users'
  import {passwordRules} from '../../validation/users'

  export default {
  	name: 'Login',
    data: () => ({
      valid: false,
      username: '',
      usernameRules: usernameRules,
      /*email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ] */
      password: '',
      passwordRules : passwordRules
    }),

     methods: {
      submit () {
        if (this.$refs.form.validate()) {
        	this.$store.dispatch('auth/login', 
        	{
        		username: this.username,
        		password: this.password
        	})
        	.then((res) => {
        		this.$store.dispatch('error/setError', undefined)
        		this.$store.commit('auth/login', res.data);
        		localStorage
        			.setItem(
        				AUTHORIZATION, res.data.token
        			);
				this.$router.push('/');

        	})
        	.catch((err) => {
        		
        		this.password = '';


        		this.$store.dispatch(
        			'error/setError',
        			this.$store.getters["translate/translater"]
        			.__(
        				"Invalid {0} or {1}",
        				"userValidation",
        				this.$store.getters["translate/translater"]
        				.__("username", "users"),
        				this.$store.getters["translate/translater"]
        				.__("password", "users")

        			)

        		)
        	})
        } 
      },
  	}
  }
</script>